import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

registerBlockType('garden/products-grid', {
    apiVersion: 3,
    title: __('Siatka produktów', 'garden'),
    icon: 'products',
    category: 'garden',
    supports: {
        anchor: true
    },
    attributes: {
        anchor: {
            type: 'string',
            default: ''
        }
    },
    edit: () => {
        const blockProps = useBlockProps({
            className: 'products-grid'
        });

        const ALLOWED_BLOCKS = ['garden/product-card'];
        const TEMPLATE = [
            ['garden/product-card'],
            ['garden/product-card'],
            ['garden/product-card'],
            ['garden/product-card']
        ];

        return (
            <div {...blockProps}>
                <div className="products-grid-container">
                    <InnerBlocks
                        allowedBlocks={ALLOWED_BLOCKS}
                        template={TEMPLATE}
                        orientation='horizontal'
                    />
                </div>
            </div>
        );
    },
    save: () => {
        const blockProps = useBlockProps.save({
            className: 'wp-block products-grid'
        });

        return (
            <div {...blockProps}>
                <div className="products-grid-container">
                    <InnerBlocks.Content />
                </div>
            </div>
        );
    }
}); 
